import { UseQueryOptions, infiniteQueryOptions } from '@tanstack/react-query';

import { SearchProductsParams, SearchProductsResponse, searchProducts } from '~/apis/search';

export const searchProductsInfiniteQueryOptions = (
  request: SearchProductsParams,
  { enabled, staleTime }: Pick<UseQueryOptions, 'enabled' | 'staleTime'>,
  token = '',
) => {
  const isServer = typeof globalThis.window === 'undefined';

  return infiniteQueryOptions({
    queryKey: ['search', 'products', 'infinite', { ...request }],
    queryFn: ({ pageParam }) => {
      return searchProducts(
        {
          ...(pageParam.a && { a: pageParam.a }),
          ...request,
          page: pageParam.page,
          filters: request.filters ?? isServer,
        },
        {
          // server-side 에서 직접 토큰 주입시 request header 에 token 직접 설정
          ...(token && {
            headers: {
              'X-BUN-AUTH-TOKEN': token,
            },
          }),
        },
      ) as Promise<SearchProductsResponse>;
    },
    initialPageParam: { page: request?.page ?? 0, a: request?.a ?? undefined },
    getNextPageParam: (lastPage, allPages, lastPageParam) => {
      const nextPage = lastPageParam.page + 1;
      const hasNotNextPage = lastPage.totalPages === 0 || lastPageParam.page + 1 === lastPage.totalPages;

      if (hasNotNextPage) return;

      return {
        page: nextPage,
        a: (lastPage as SearchProductsResponse & { after: number[] }).after,
      };
    },
    select: (data) => {
      const { pages, pageParams } = data;
      const pageIndex = pages?.length - 1;

      return {
        ...pages?.[pageIndex],
        category: pages?.[0].category,
        filters: pages?.[0].filters,
        pages: pages?.flatMap(({ data }) => data).filter((data) => data),
        page: pageParams?.[pageIndex].page,
      };
    },
    placeholderData: (data) => data,
    enabled,
    staleTime: staleTime ?? 3 * 1000,
    throwOnError: true,
    retry: 0,
    refetchOnWindowFocus: false,
  });
};
